/**
 * Tiny className concatenator. Same shape as the admin's so anyone who
 * jumps between codebases gets the same DX.
 */
export function cn(...inputs) {
  const out = [];
  for (const input of inputs) {
    if (!input) continue;
    if (typeof input === "string") {
      out.push(input);
    } else if (typeof input === "object") {
      for (const [k, v] of Object.entries(input)) if (v) out.push(k);
    }
  }
  return out.join(" ");
}
